/**
 * Round-up engine.
 *
 * The single most important invariant (docs/BRIEF §10-11, §17):
 *   - amounts are integer pence
 *   - an exact-increment purchase produces a ZERO round-up
 *   - the round-up is the MAXIMUM ever debited from the reserve; all fees
 *     come out of the round-up, never on top of it.
 */

export type RoundingIncrement = 100 | 200 | 500; // pence

export const ROUNDING_OPTIONS: { value: RoundingIncrement; label: string }[] = [
  { value: 100, label: "Nearest £1" },
  { value: 200, label: "Nearest £2" },
  { value: 500, label: "Nearest £5" },
];

/**
 * £3.42 with £1 rounding → 58p. £5.00 with £1 rounding → 0p.
 */
export function calcRoundupPence(purchasePence: number, incrementPence: RoundingIncrement): number {
  if (!Number.isInteger(purchasePence) || purchasePence <= 0) return 0;
  const remainder = purchasePence % incrementPence;
  return remainder === 0 ? 0 : incrementPence - remainder;
}

/** The amount the purchase is "rounded to", for display. */
export function roundedToPence(purchasePence: number, incrementPence: RoundingIncrement): number {
  return purchasePence + calcRoundupPence(purchasePence, incrementPence);
}
